import { Component, createContext, useContext } from 'react';
import { createPortal, render } from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export const PortalLayerContext = /*#__PURE__*/createContext({
  preserveScrollOnClose: false
});
function saveScrollPositions(el) {
  return {
    top: el.scrollTop,
    left: el.scrollLeft,
    children: Array.from(el.children).map(saveScrollPositions)
  };
}
function restoreScrollPositions(el, snapshot) {
  el.scrollTop = snapshot.top;
  el.scrollLeft = snapshot.left;
  Array.from(el.children).forEach((child, i) => {
    if (snapshot.children[i]) {
      restoreScrollPositions(child, snapshot.children[i]);
    }
  });
}
class PortalLayer extends Component {
  componentWillUnmount() {
    const {
      element,
      preserveScrollOnClose,
      renderTree
    } = this.props;
    const closeTransitionTree = renderTree(null);
    if (!closeTransitionTree) return;
    const firstChild = element.firstChild;
    if (!firstChild || !firstChild.children) return;
    const originalTransitionContents = Array.from(firstChild.children).map(childElement => ({
      clone: childElement.cloneNode(true),
      scrollSnapshot: preserveScrollOnClose ? saveScrollPositions(childElement) : null
    }));
    const closeTransitionContainer = document.createElement('div');
    element.appendChild(closeTransitionContainer);
    closeTransitionContainer.addEventListener('click', e => {
      // clones are not interactive, preventing unexpected behavior during close
      e.preventDefault();
    });
    render(closeTransitionTree, closeTransitionContainer, () => {
      originalTransitionContents.forEach(({
        clone,
        scrollSnapshot
      }) => {
        if (closeTransitionContainer.firstChild !== null) {
          closeTransitionContainer.firstChild.appendChild(clone);
          if (scrollSnapshot) {
            restoreScrollPositions(clone, scrollSnapshot);
          }
        }
      });
    });
  }
  render() {
    const {
      children,
      element,
      renderTree
    } = this.props;
    const tree = renderTree(children);
    return /*#__PURE__*/createPortal(tree, element);
  }
}
PortalLayer.displayName = 'PortalLayer';
function PortalLayerWithContext(props) {
  const {
    preserveScrollOnClose
  } = useContext(PortalLayerContext);
  return /*#__PURE__*/_jsx(PortalLayer, Object.assign({}, props, {
    preserveScrollOnClose: preserveScrollOnClose
  }));
}
export { PortalLayerWithContext as PortalLayer };